<template>
  <mu-list class="resource-list">
    <div
      v-for="(item, index) in list"
      :key="item.id"
      @click="transferData(item, index)"
    >
      <mu-list-item
        :class="{ active: item.id === currentId }"
        class="resource-item"
      >
        <mu-list-item-action class="icon-position">
          <mu-icon :value="iconValue" size="20"></mu-icon>
        </mu-list-item-action>

        <mu-list-item-content>
          <mu-list-item-title>
            {{ item.title }}
            <small>{{ tryStr(item.view_all) }}</small>
          </mu-list-item-title>
        </mu-list-item-content>

        <mu-list-item-action>
          {{ getDesc(item) }}
        </mu-list-item-action>
      </mu-list-item>
      <mu-divider />
    </div>
  </mu-list>
</template>

<script>
import { fetchCourseChapterDetailsItemRecord } from '@/api/index'
export default {
  props: {
    type: {
      type: Number,
    },
    list: {
      type: Array,
    },
    iconValue: {
      type: String,
    },
    completeFirst: {
      type: Boolean,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
    isRecord: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentId: null,
      panel: '',
      one: null,
    }
  },

  computed: {},

  watch: {
    completeFirst(val) {
      if (val) {
        const list = this.list
        if (Array.isArray(list) || list.length > 0) {
          // if (this.isRecord) {
          // 播放记录功能，遍历列表，启动最近一个未播放完成的视频
          var allFinish = true
          for (let i = 0; i < list.length; i++) {
            if (!list[i].is_finish) {
              this.transferData(list[i])
              allFinish = false
              break
            }
          }
          // 全部播放完毕从头播放
          if (allFinish) this.transferData(list[0])
        }
      }
    },
    currentIndex: {
      // 索引变化则切换到对应媒体项
      handler(val, old) {
        if (val === old) return
        const list = this.list
        if (val <= list.length - 1) {
          this.transferData(list[val], val)
        }
      },
    },
  },

  methods: {
    tryStr(viewAll) {
      let str
      if (this.type === 0) {
        str = '（试看）'
      } else if (this.type === 1) {
        str = '（试听）'
      }
      return viewAll ? '' : str
    },
    getDesc(item) {
      let str
      if (this.isRecord) {
        str = item.percent
      } else if (item.view_all === 1) {
        str = item.content ? this.formatTime(item.content.Duration) : ''
      } else {
        str = item.material_content
          ? this.formatTime(item.material_content.Duration)
          : ''
      }
      return str
    },
    formatTime(second) {
      function zeroize(num) {
        return num < 10 ? '0' + num : num
      }
      const hour = ~~(second / 3600)
      const modHour = second % 3600

      const minute = ~~(modHour / 60)

      const sec = ~~modHour % 60

      const result = `${zeroize(hour)}:${zeroize(minute)}:${zeroize(sec)}`
      return result
    },
    transferData(info, index = 0) {
      if (!info) return
      if (info.id === this.currentId) {
        this.$emit('repeatClick')
        return
      }
      if (this.$root.$data.isStudent) {
        fetchCourseChapterDetailsItemRecord({ course_id: info.id })
      }
      this.currentId = info.id
      info.index = index
      this.$emit('getData', info)
    },
    toggle(panel) {
      this.panel = panel === this.panel ? '' : panel
    },
  },
}
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.resource-list {
  font-size: 14px;
  line-height: 1.1;

  margin: {
    top: 0;
    bottom: 0;
  }
  padding: {
    top: 10px;
    right: 30px;
    bottom: 15px;
    left: 50px;
  }
  list-style-type: none;
  .title {
    font-size: 1.1em;
    //   font-weight: bold;

    //   padding-top: 10px;
    //   padding-bottom: 5px;

    //   color: #2b333b;
  }

  .resource-item {
    margin: {
      top: 15px;
    }
    // padding: 13px 10px 8px;

    cursor: pointer;
    // transition: all 0.3s;
    // transform: translateZ(0);

    // border-bottom: 1px solid #ebeff7;
    // background: #fff;
    // box-shadow: 4px 4px 8px 0 rgba(0, 0, 0, 0.1);
    &.active,
    &.active .mu-item-action,
    &.active .mu-item {
      transition: all 0.3s;

      color: #214ecf;
      // font-size: 1.5em !important;
      // font-weight: bold;
      // transform: scale(1.02);
      // border-left: 6px solid #99d2ff;
      // box-shadow: 4px 4px 8px 0 #99d2ff !important;
    }

    .icon-position {
      position: absolute;
      left: -31px;
      top: 0px;
    }
    .mu-item {
      padding: 0;
      height: 30px;
    }
  }
}
</style>
